import type {
  ChatMessage,
  PromptRequest,
  PromptCompletion,
} from "~/chat/types/chat";
import { parseStreamedCompletionResponse } from "~/chat/utils/parse-streamed-completion-response";
import { normalizeFilename } from "~/chat/utils/normalize-filename";

type SendChatPromptParams = {
  signal?: AbortSignal;
  conversationId: number;
  workspaceId: number;
  files?: File[] | null;
};

async function* sendChatPrompt(
  { content }: ChatMessage,
  { signal, conversationId, workspaceId, files }: SendChatPromptParams,
): AsyncGenerator<PromptCompletion> {
  const request: PromptRequest = {
    query: content,
    /* eslint-disable camelcase */
    conversation_id: conversationId,
    workspace_id: workspaceId,
    /* eslint-enable camelcase */
  };

  let body: BodyInit;

  if (files) {
    const form = new FormData();
    form.append(
      "data",
      new Blob([JSON.stringify(request)], { type: "application/json" }),
    );
    for (const file of files) {
      form.append("files", file, normalizeFilename(file.name));
    }

    body = form;
  } else {
    body = JSON.stringify(request);
  }

  const response = await fetch("/api/chat", {
    method: "POST",
    headers: files ? undefined : { "Content-Type": "application/json" },
    body,
    signal,
  });

  yield* parseStreamedCompletionResponse(response);
}

export { sendChatPrompt };
